declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveProviderServiceChargeRequest } from '../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../models/master/mastermodel';
import { FDService } from '../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbeditconsultant',
  templateUrl: './editconsultant.modal.html',
  styleUrls: ['./editconsultant.modal.scss']
})

export class NgbEditConsultantModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEmploymentPreferencesRequest: ActorEmploymentPreferencesRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
 
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
  CurrentSaveProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  CurrentDeleteProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.CurrentSaveProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    //this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 20;
    this.CurrentSaveProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentDeleteProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    this.CurrentDeleteProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;
    

    this.LoadRegistries();
    

  }

  
  SelectedConsultantMapData: ServiceConsultantMapController[];
  SelectedConsultantMapRequest: ServiceConsultantMapRequest;
  ConsultantMapData: ServiceConsultantMapController[];
  ConsultantMapRequest: ServiceConsultantMapRequest;
  CurrentCustomCodeTypeRequest: CustomCodeTypeRequest_;
  CurrentCustomCodeValuesController: CustomCodeValuesController_[];
  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
 //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.StartRefreshing();


    this.SelectedConsultantMapRequest = new ServiceConsultantMapRequest();
    this.SelectedConsultantMapRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ConsultantMapRequest = new ServiceConsultantMapRequest();
    this.ConsultantMapRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.BranchMapRequest = new ServiceBranchMapByServiceCodeRequest();
    //this.BranchMapRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = CurrentCustomCodeValuesController;
    this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest_();

    this.CurrentCustomCodeTypeRequest.RequestedType = "AllConsultantsAllFacilities";
    this.CurrentCustomCodeTypeRequest.FacilityCode = 0;
    this.CurrentCustomCodeTypeRequest.ActorCode = 0;
    this.CurrentCustomCodeTypeRequest.CustomCode = 0;
    this.CurrentCustomCodeTypeRequest.CustomType = "";
    this.CurrentCustomCodeTypeRequest.StringContains = "";
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentCustomCodeValuesController;
    this.GetConsultantMap();
 
    this.GetConsulants();
    //this.GetBranchMap();

    this.CurrentServiceDetailsByCodeRequest = new ServiceDetailsByCodeRequest();
    this.CurrentServiceDetailsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetServiceDetailsByCodeController();

  }
  GetConsultantMap() {
    //alert("consultantmodal");
    this.StartRefreshing();
    this.ConsultantMapRequest.ServiceCode = this.ServiceCode;
    this.ConsultantMapRequest.ProviderCode = -1;//parseInt( this.SelectedProvider.Consultant);

    this.actorservice.GetServiceConsultantMapControllerController(this.ConsultantMapRequest)
      .subscribe((result) => {
     
        this.ApiResData = result;
     //   alert(this.ApiResData.Result);
        if (!this.ApiResData.hasError) {

          this.ConsultantMapData = this.ApiResData.Result;
          //alert(this.ConsultantMapData[0].DisplayName);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );




  }

  GetSelectedConsultantMap() {
    this.StartRefreshing();
    this.SelectedConsultantMapRequest.ServiceCode = this.ServiceCode;
  //  alert(this.SelectedProvider.Code);
    this.SelectedConsultantMapRequest.ProviderCode =
      this.SelectedProvider.Code;////parseInt(this.SelectedProvider.Consultant);

    this.actorservice.GetServiceConsultantMapControllerController(this.SelectedConsultantMapRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        //   alert(this.ApiResData.Result);
        if (!this.ApiResData.hasError) {

          this.SelectedConsultantMapData = this.ApiResData.Result;
          //alert(this.ConsultantMapData[0].DisplayName);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );



  }
  pdata: any[];
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCustomCodeValuesController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCustomCodeValuesController, this.listFilter);
      }
    }
  }
  //GetBranchMap() {
  //  this.StartRefreshing();
  //  this.BranchMapRequest.ServiceCode = this.ServiceCode;

  //  this.actorservice.GetServiceBranchMapByServiceCodeController(this.BranchMapRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.BranchMapData = this.ApiResData.Result;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );


  //}
  CurrentServiceDetailsByCodeRequest: ServiceDetailsByCodeRequest;
  CurrentServiceDetailsByCodeController: ServiceDetailsByCodeController[];
  GetConsulants() {
    this.StartRefreshing();

    this.fdservice.GetCustomDataByRequestedType_(this.CurrentCustomCodeTypeRequest).subscribe
      (

      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCustomCodeValuesController = this.ApiResData.Result;
          this.CurrentCustomCodeValuesController.splice(0, 1);
          this.pdata = this.CurrentCustomCodeValuesController;
          //this.pdata = this.CurrentCustomCodeValuesController;
          this.stopRefreshing();

          //this.GetFdActorReportsDocController();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            alert(' Failed Due to Internal Error.... Please Contact Admin..');
          }
        }

      },
      (error) => {

        if (error == "401 - Unauthorized") {
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
        }
      }
      //
      );;
  }
  SelectedService: ServiceDetailsByCodeController;
  GetServiceDetailsByCodeController() {
    //alert("calling GetServiceDetailsByCodeController")
    this.StartRefreshing();
    this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
    this.actorservice.GetServiceDetailsByCodeController(this.CurrentServiceDetailsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentServiceDetailsByCodeController = this.ApiResData.Result;
          this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.SelectedService.Name);
          
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  RadioAssignChange(value: any) {

    //alert(value);
    var selected: ServiceConsultantMapController = value;
    
    var ind: number = 0;
    while (ind < this.ConsultantMapData.length) {
      if (selected != this.ConsultantMapData[ind]) {
        this.ConsultantMapData[ind].IsSelected = false;

      }
      else {


      }
      ind++;
    }

  }
  OnDelete(l:any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(l: ServiceConsultantMapController) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentDeleteProviderServiceChargeRequest.ConditionalOperator = 30;
    this.CurrentDeleteProviderServiceChargeRequest.ProviderCode = this.SelectedProvider.Code;
    this.CurrentDeleteProviderServiceChargeRequest.ProviderServiceChargeCode = l.ConsultantServiceCode;
    this.CurrentDeleteProviderServiceChargeRequest.Price = l.ChargeAmount;
    this.CurrentDeleteProviderServiceChargeRequest.Commission = l.CommissionAmount;
    this.CurrentDeleteProviderServiceChargeRequest.BranchCode = l.BranchCode;
    this.CurrentDeleteProviderServiceChargeRequest.ServiceCode = this.ServiceCode;
    this.CurrentDeleteProviderServiceChargeRequest.CreatedBy = AppData.Instance().UserLoginDetails.ActorCode;

    
    this.actorservice.SaveProviderServiceChargeInfo(this.CurrentDeleteProviderServiceChargeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadDocuments();

            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }
          this.GetSelectedConsultantMap();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  onSubmit(l: ServiceConsultantMapController) {

    this.StartRefreshing();
    if (l.ConsultantServiceCode == 0) {
      this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 10;

    }
    else {
      this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 20;

    }
    this.CurrentSaveProviderServiceChargeRequest.ProviderCode = this.SelectedProvider.Code;
    this.CurrentSaveProviderServiceChargeRequest.ProviderServiceChargeCode = l.ConsultantServiceCode;
    this.CurrentSaveProviderServiceChargeRequest.Price = l.ChargeAmount;
    this.CurrentSaveProviderServiceChargeRequest.Commission = l.CommissionAmount;
    this.CurrentSaveProviderServiceChargeRequest.BranchCode = l.BranchCode;
    this.CurrentSaveProviderServiceChargeRequest.ServiceCode = this.ServiceCode;
    this.CurrentSaveProviderServiceChargeRequest.CreatedBy = AppData.Instance().UserLoginDetails.ActorCode;

 


    this.actorservice.SaveProviderServiceChargeInfo(this.CurrentSaveProviderServiceChargeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
         // alert(this.ApiResData.Result);
          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            
            

            this.stopRefreshing();
          }
          else {
         //   alertFunctions.AlertParam("Invalid Operation...!");
            

            this.stopRefreshing();

          }
          this.GetSelectedConsultantMap();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
           


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
         
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
        
          this.stopRefreshing();
        }
      }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  SelectedProvider: CustomCodeValuesController_;
  viewprovider(obj: any) {
    //alert(obj.Code);
    var Provider: CustomCodeValuesController_ = obj;
    if (Provider != null) {
     // this.SelectedProvider = null;
      this.SelectedProvider = Provider;
  //    alert(this.SelectedProvider.Code);
      this.ShowService = true;
      this.GetSelectedConsultantMap();
    }
    else {
      this.SelectedProvider = null;
      this.ShowService = false;
    }
    
    
   
  }
 



}
